import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Button } from '../Components/ui/button.js';
import { cn } from '../lib/utils.js';
import { ArrowDownIcon } from 'lucide-react';
import { useCallback } from 'react';
import { StickToBottom, useStickToBottomContext } from 'use-stick-to-bottom';

const Conversation = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(StickToBottom, Object.assign({ className: cn('tw:relative tw:flex-1 tw:overflow-y-auto', className), initial: "smooth", resize: "smooth", role: "log" }, props)));
};
const ConversationContent = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsx(StickToBottom.Content, Object.assign({ className: cn('tw:p-4', className) }, props)));
};
const ConversationScrollButton = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const { isAtBottom, scrollToBottom } = useStickToBottomContext();
    const handleScrollToBottom = useCallback(() => {
        scrollToBottom();
    }, [scrollToBottom]);
    return (!isAtBottom && (jsx(Button, Object.assign({ className: cn('tw:absolute tw:bottom-4 tw:left-[50%] tw:translate-x-[-50%] tw:!rounded-full', 'tw:bg-white/50 tw:backdrop-blur-md tw:border-white/30 tw:shadow-lg', 'hover:tw:bg-white/70', className), onClick: handleScrollToBottom, size: "icon", type: "button", variant: "outline" }, props, { children: jsx(ArrowDownIcon, { className: "tw:size-4 tw:text-gray-700" }) }))));
};

export { Conversation, ConversationContent, ConversationScrollButton };
//# sourceMappingURL=conversation.js.map
